import api from '../../../services/api';
import { normalizeOrderFulfillmentSourceDto } from '../../../dto/orderFulfillment';
import type { OrderFulfillmentSourceDto } from '../../../types/order';

export type { OrderFulfillmentSource, OrderFulfillmentSourceDto } from '../../../types/order';

export async function fetchOrderFulfillmentSource(
  orderId: string,
): Promise<OrderFulfillmentSourceDto> {
  const response = await api.get<OrderFulfillmentSourceDto>(
    `/orders/${orderId}/fulfillment-source`,
  );
  return normalizeOrderFulfillmentSourceDto(response.data);
}
